import cn from 'classnames'
import { getImage } from '../../../../utilities/iconResolver'
import { ReactSVG } from 'react-svg'
import Checkbox from '../../../customize-button/components/form/Checkbox'
import { t } from '../../../../utilities/translator'
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks'
import { setCurrentStep, setVisibleSteps } from '../../onboardingSlice'
import { createPortal } from 'react-dom'
import { pushEvent } from '../../../../utilities/analytics'
import { WIZARD_DYNAMIC_QUESTION_ANSWERED } from '../../../../constants/analyticEvents'

type Props = {
  counterLabel: string,
  isLast?: boolean
}

// TODO: There is a problem, when user uncheck facilities and he had already selected options from following step, it will still save selection.
// It should clear selection from following step.
const FacilitiesStep = ({ counterLabel }: Props) => {
  const dispatch = useAppDispatch();
  const facilities = useAppSelector(state => state.onboarding.stepsConfig.facilities);
  const footerPortal = document.getElementById('wizard-next-button');

  const handleOptionClick = (value: boolean) => {
    dispatch(setVisibleSteps({ facilities: value }));
    setTimeout(() => {
      dispatch(setCurrentStep(1));
    }, 200);
  }

  const handleNotRelevantClick = () => {
    pushEvent(WIZARD_DYNAMIC_QUESTION_ANSWERED, {
      name: 'Show facilities',
      answer: 'not relevant',
    })
    dispatch(setCurrentStep(1));
  }

  const handleContinueClick = () => {
    dispatch(setCurrentStep(1));

    pushEvent(WIZARD_DYNAMIC_QUESTION_ANSWERED, {
      name: 'Show facilities',
      answer: facilities ? 'Yes' : 'No',
    })
  }

  return (
    <div>
      <div className="wizard-step gap-10 wizard-question">
        <div className="text-center">
          <ReactSVG src={getImage('hotel-label.svg')} />
        </div>
        <div className="flex flex-col gap-3 text-center items-center">
          <span className="text-tertiary font-medium text-sm">{counterLabel}</span>
          <div className="wizard-step__title">{t('onboarding.facilitiesPreselectionTitle')}</div>
        </div>
        <div className="flex flex-col gap-5">
          <div className={cn('wizard-checkbox-option', { selected: facilities === true })} onClick={() => handleOptionClick(true)}>
            <Checkbox
              label={t('onboarding.facilitiesPreselectionYes')}
              wrapClassNames="pointer-events-none"
              checked={facilities === true}
            />
          </div>
          <div className={cn('wizard-checkbox-option', { selected: facilities === false })} onClick={() => handleOptionClick(false)}>
            <Checkbox
              label={t('onboarding.facilitiesPreselectionNo')}
              wrapClassNames="pointer-events-none"
              checked={facilities === false}
            />
          </div>
        </div>
        <div className="text-center text-tertiary text-sm underline cursor-pointer" onClick={handleNotRelevantClick}>
          {t('onboarding.notRelevant')}
        </div>
        {footerPortal ? createPortal(
          <button className="wizard-control-button" onClick={handleContinueClick}>{t('onboarding.continue')}</button>,
          footerPortal
        ) : (
          <div className="wizard-footer">
            <button className="wizard-control-button" onClick={handleContinueClick}>{t('onboarding.continue')}</button>
          </div>
        )}
      </div>
    </div>
  )
}

export default FacilitiesStep
